import { Button } from "@mui/material";

import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import useDeleteConfirmationModal from "../hooks/useDeleteConfirmationModal";

const DeleteConfirmationModal = () => {
  const {
    showDeleteConfirmationModal,
    handleModalClose,
    isProcessing,
    handleDeleteInsurance,
  } = useDeleteConfirmationModal();
  return (
    <ModalWrapper
      show={showDeleteConfirmationModal}
      onClose={handleModalClose}
      fullWidth
      title={<span>Delete Insurance</span>}
    >
      <div>Are you sure you want to delete this insurance?</div>
      <div className="d-flex flex-end" style={{ gap: "10px", marginTop: 15 }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleModalClose}
          disabled={isProcessing}
        >
          Cancel
        </Button>

        <Button
          color="secondary"
          variant="contained"
          onClick={handleDeleteInsurance}
          disabled={isProcessing}
        >
          Confirm
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default DeleteConfirmationModal;
